import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchEnrichedDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 116 116",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#002F77",
			d: "M58 109c28.166 0 51-22.834 51-51S86.166 7 58 7 7 29.834 7 58s22.834 51 51 51Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D8FFFF",
			d: "M88.7 27.44a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00D8D8",
			d: "m12.623 79.502 3.94-3.94c.59-.59.59-1.54 0-2.12-.59-.58-1.54-.59-2.12 0l-3.94 3.94-3.94-3.94a1.49 1.49 0 0 0-2.12 0c-.58.59-.59 1.54 0 2.12l3.94 3.94-3.94 3.94a1.49 1.49 0 0 0 0 2.12c.29.29.68.44 1.06.44s.77-.15 1.06-.44l3.94-3.94 3.94 3.94c.29.29.68.44 1.06.44s.77-.15 1.06-.44c.59-.59.59-1.54 0-2.12l-3.94-3.94ZM27.6 91.08a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM83.64 9.07h-5.57V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v5.57H69.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h5.57v5.57c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-5.57h5.57c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5ZM42 112c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6Zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm56.04-1.71a4.21 4.21 0 0 1-3-1.25L76.36 80.36a4.249 4.249 0 1 1 6.01-6.01l18.68 18.68a4.249 4.249 0 0 1 0 6.01c-.83.83-1.92 1.25-3 1.25h-.01Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0597A3",
			d: "M56.51 86.8c17.905 0 32.42-14.515 32.42-32.42S74.415 21.96 56.51 21.96 24.09 36.475 24.09 54.38 38.605 86.8 56.51 86.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#00D8D8",
			d: "M56.51 79.69c13.979 0 25.31-11.332 25.31-25.31 0-13.979-11.331-25.31-25.31-25.31-13.978 0-25.31 11.331-25.31 25.31 0 13.978 11.332 25.31 25.31 25.31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D8FFFF",
			d: "M71.76 48.4c-.8 0-1.57-.43-1.98-1.18a15.067 15.067 0 0 0-13.27-7.91c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25c7.2 0 13.8 3.94 17.22 10.27.59 1.09.18 2.46-.91 3.05-.34.18-.71.27-1.07.27h.01Z"
		})
	]
});
export default SvgSearchEnrichedDark;
